import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { MIRAGE, WHITE } from '../styles';
import Text from '../components/Text';
import image from '../assets/wt_logo.png';
import Wrapper from './Wrapper';

const s = StyleSheet.create({
  root: {
    width: '100%',
    height: 50,
    backgroundColor: MIRAGE,
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    opacity: 0.5,
    paddingTop: 15,
  },
  text: {
    color: WHITE,
    fontSize: 12,
    letterSpacing: '0.16px',
  },
  image: {
    width: '70px',
    marginLeft: 5,
  },
});

const Footer = () => (
  <footer className={css(s.root)}>
    <Wrapper>
      <div className={css(s.wrapper)}>
        <Text messageId="app.footer.contact" className={css(s.text)} />
        <a href="mailto:BUD.RedBullTeam@wundermanthompson.com">
          <img src={image} className={css(s.image)} alt="possible" />
        </a>
      </div>
    </Wrapper>
  </footer>
);

export default Footer;
